import React from 'react'
import { Menu, useAuthenticationContext } from '@rededor/crdsl'
import { MenuUserProfileProps } from '@rededor/crdsl/dist/components/AuthenticationProvider/useMenu'
import PreenchimentoConsultaHelper from '../../utils/helpers/preenchimentoConsultaHelper'
import {
  acessoLogadoEstaAtivo,
  obtemStatusDeAcessoLogado
} from '../../utils/helpers/acessoLogadoHelper'
import b2cLinks from '../../consts/b2cLinks'
import logoLinks from '../../consts/logoLinks'

function NavBarT() {
  const { menuItems, menuLinks } = useAuthenticationContext()

  const linkEntrar = menuLinks.find(link => link.id === 'entrar')
  const linkLogout = menuLinks.find(link => link.id === 'logout')
  const linkLogo = menuLinks.find(link => link.id === 'logo')

  if (linkEntrar) {
    linkEntrar.url = b2cLinks.login
  }

  if (linkLogout) {
    linkLogout.url = b2cLinks.logout
  }

  if (linkLogo) {
    linkLogo.url = acessoLogadoEstaAtivo()
      ? logoLinks.logado
      : logoLinks.deslogado
  }

  const realizaArmazenamentoDosDadosPreenchidos = (): Promise<void> =>
    new Promise(resolve => {
      PreenchimentoConsultaHelper.realizaPreenchimento()
      resolve()
    })

  const userProfile: MenuUserProfileProps = {}

  if (acessoLogadoEstaAtivo()) {
    const { usuarios } = obtemStatusDeAcessoLogado()
    if (usuarios && usuarios.logado) {
      userProfile.name = usuarios.logado.nome
      userProfile.avatar = usuarios.logado.avatar
    }
  }

  return (
    <div className="ref-navbar">
      <Menu
        data-qa-id="NavBarT_Menu"
        fluid
        active="agendamento-consulta"
        context={acessoLogadoEstaAtivo() ? 'logado' : 'deslogado'}
        links={menuLinks}
        items={menuItems}
        userProfile={userProfile}
        beforeLoginClickAction={() => realizaArmazenamentoDosDadosPreenchidos()}
        beforeLogoutClickAction={() => {
          return new Promise(resolve => {
            PreenchimentoConsultaHelper.removeDados()
            resolve()
          })
        }}
        beforeProfileClickAction={async () =>
          realizaArmazenamentoDosDadosPreenchidos()
        }
      />
    </div>
  )
}

export default NavBarT
